var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogoLiqpayMain(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "100%",
    height: "100%",
    viewBox: "0 0 150 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "prefix__a",
    x1: "12.285%",
    x2: "87.742%",
    y1: "73.775%",
    y2: "26.331%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#1FADC3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "70.72%",
    stopColor: "#36B98F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "prefix__b",
    x1: "47.881%",
    x2: "59.926%",
    y1: "38.082%",
    y2: "13.982%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#123F06",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#123F06"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "prefix__d",
    x1: "15.45%",
    x2: "74.311%",
    y1: "24.157%",
    y2: "72.02%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#9FDB57"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#71CA5E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "prefix__e",
    x1: "12.217%",
    x2: "87.674%",
    y1: "73.818%",
    y2: "26.374%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#1FADC3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "70.72%",
    stopColor: "#36B98F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "prefix__g",
    x1: "15.481%",
    x2: "74.342%",
    y1: "24.182%",
    y2: "72.045%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#9FDB57"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#71CA5E"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "prefix__c",
    cx: "-348.129%",
    cy: "133.909%",
    r: "497.59%",
    fx: "-348.129%",
    fy: "133.909%",
    gradientTransform: "matrix(1 0 0 .875 0 .167)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "41.85%",
    stopColor: "#123F06",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#123F06"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "prefix__f",
    cx: "-347.288%",
    cy: "133.909%",
    r: "497.59%",
    fx: "-347.288%",
    fy: "133.909%",
    gradientTransform: "matrix(1 0 0 .875 0 .167)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "41.85%",
    stopColor: "#123F06",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#123F06"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "url(#prefix__a)",
    d: "M1.107 24.197l-.345-.295c-.836-.713-.983-2.017-.221-2.853l8.95-10.23c.714-.835 2.017-.983 2.853-.22l.345.294c.836.714.983 2.017.22 2.853l-8.95 10.23c-.713.835-1.967.934-2.852.22z",
    transform: "translate(125.164)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#prefix__b)",
    d: "M8.287 12.59l-.172-.197-1.377 1.574.147.172c2.36 2.361 1.353 4.746.812 5.582l.196-.221c.32-.369.812-.934 1.328-1.55.541-.934 1.304-3.147-.934-5.36z",
    opacity: 0.4,
    transform: "translate(125.164)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#prefix__c)",
    d: "M11.238 15.664l.369-.418c.024-.05.073-.098.098-.148-.394.443-.812.91-1.205 1.377.295-.32.541-.59.738-.811z",
    opacity: 0.4,
    transform: "translate(125.164)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#prefix__d)",
    d: "M12.959 11.14L4.009.91C3.294.074 1.991-.074 1.155.689L.81.984C-.025 1.697-.172 3 .591 3.836l7.548 8.557.172.197c2.238 2.238 1.476 4.451.91 5.385.443-.516.886-1.032 1.304-1.5.393-.467.811-.934 1.205-1.377.393-.442.762-.86 1.008-1.13.86-.837.983-1.993.221-2.829z",
    transform: "translate(125.164)"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "url(#prefix__e)",
    d: "M1.156 24.197l-.345-.295c-.836-.713-.983-2.017-.22-2.853l8.95-10.23c.713-.835 2.016-.983 2.852-.22l.345.294c.836.714.983 2.017.221 2.853l-8.95 10.23c-.714.835-1.968.934-2.853.22z",
    transform: "translate(125.164) translate(11.311)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#prefix__b)",
    d: "M8.434 12.492l-.172-.197-1.377 1.574.148.172c2.36 2.36 1.352 4.746.811 5.582l.197-.221c.32-.37.811-.935 1.328-1.55.54-.934 1.303-3.147-.935-5.36z",
    opacity: 0.4,
    transform: "translate(125.164) translate(11.311)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#prefix__f)",
    d: "M11.262 15.664l.37-.418c.024-.05.073-.098.098-.148-.394.443-.812.91-1.205 1.377.295-.32.565-.59.737-.811z",
    opacity: 0.4,
    transform: "translate(125.164) translate(11.311)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#prefix__g)",
    d: "M12.984 11.14L4.033.91C3.32.074 2.016-.074 1.18.689L.836.984C0 1.697-.148 3 .615 3.836l7.549 8.557.172.197c2.238 2.238 1.475 4.451.91 5.385.443-.516.885-1.032 1.303-1.5.394-.467.812-.934 1.205-1.377.394-.442.762-.86 1.008-1.13.861-.837.984-1.993.222-2.829z",
    transform: "translate(125.164) translate(11.311)"
  }))), /*#__PURE__*/React.createElement("g", {
    fill: "#4B4C4B"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M.566 24.098c-.345-.344-.541-.86-.541-1.5V2.361c0-.664.196-1.18.614-1.599.418-.418.935-.614 1.599-.614.664 0 1.254.196 1.647.614.418.418.615.935.615 1.599v18.664h9.664c1.377 0 2.09.614 2.09 1.82 0 1.204-.713 1.819-2.09 1.819H2.114c-.663 0-1.18-.197-1.548-.566zM19.746 24.246c-.418-.418-.615-.96-.615-1.648V2.336c0-.664.197-1.18.615-1.598.418-.418.934-.615 1.598-.615s1.254.197 1.648.615c.418.418.615.934.615 1.598v20.262c0 .664-.197 1.23-.615 1.648-.418.418-.96.615-1.648.615-.64 0-1.18-.197-1.598-.615z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "nonzero",
    d: "M48.787 28.033c.246.418.393.811.393 1.23 0 .516-.196.958-.614 1.278-.418.32-.91.516-1.451.516-.418 0-.812-.098-1.18-.295-.345-.196-.665-.492-.91-.86l-2.017-3.345c-.32-.54-.738-.934-1.254-1.18-.516-.246-1.18-.393-2.016-.393-2.386 0-4.427-.517-6.172-1.5-1.746-1.033-3.074-2.484-4.009-4.328-.934-1.894-1.401-4.107-1.401-6.615 0-2.533.492-4.721 1.401-6.615.935-1.869 2.287-3.295 4.009-4.328 1.745-1.032 3.786-1.5 6.172-1.5 2.336 0 4.401.517 6.123 1.5 1.746 1.033 3.073 2.484 4.008 4.328.934 1.87 1.401 4.082 1.401 6.615 0 2.73-.54 5.115-1.647 7.057-1.082 1.968-2.656 3.394-4.697 4.304 1.058.344 1.918 1.13 2.631 2.287l1.23 1.844zm-3.86-8.926c1.253-1.55 1.893-3.763 1.893-6.615 0-2.902-.64-5.066-1.894-6.615-1.254-1.55-2.975-2.287-5.237-2.287-2.263 0-4.009.762-5.263 2.287-1.254 1.55-1.893 3.713-1.893 6.615 0 2.901.64 5.065 1.893 6.615 1.254 1.549 3.025 2.311 5.263 2.311 2.237 0 3.983-.762 5.237-2.311zM56.68 24.246c-.418-.418-.614-.96-.614-1.648V2.41c0-.664.196-1.18.59-1.55.393-.344.91-.54 1.574-.54h8.483c2.607 0 4.623.639 6.074 1.967 1.45 1.279 2.188 3.123 2.188 5.459 0 2.336-.737 4.18-2.188 5.484-1.45 1.327-3.467 1.967-6.074 1.967h-6.172v7.426c0 .713-.197 1.254-.615 1.647-.418.419-.959.615-1.647.615-.664-.024-1.23-.221-1.599-.64zm9.468-12.443c3.049 0 4.598-1.352 4.598-4.008 0-2.656-1.55-4.008-4.598-4.008H60.54v7.992l5.607.024zM98.508 22.893c0 .517-.221.96-.64 1.353-.417.344-.909.54-1.475.54-.344 0-.713-.097-1.032-.294-.32-.197-.59-.517-.763-.91l-2.09-4.623H80.41l-2.09 4.623c-.197.418-.443.713-.763.91-.32.197-.664.295-1.057.295-.516 0-1.033-.197-1.45-.541-.443-.344-.64-.812-.64-1.353 0-.295.074-.614.197-.91L84.147 1.5c.197-.443.517-.811.96-1.057.418-.246.86-.345 1.352-.345.492 0 .934.123 1.352.345.419.246.738.59.96 1.057l9.565 20.484c.098.32.172.59.172.91zM81.91 15.516h9.123l-4.574-10.23-4.55 10.23z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.721.148c.517 0 .984.196 1.402.614.418.418.615.861.615 1.451 0 .443-.172.91-.517 1.328l-7.844 9.566v9.565c0 .713-.197 1.254-.615 1.672-.418.418-.934.59-1.573.59-.664 0-1.23-.196-1.648-.59-.418-.393-.615-.934-.615-1.672v-9.565l-7.795-9.59c-.344-.419-.516-.861-.516-1.328 0-.541.196-1.033.615-1.451.418-.418.91-.615 1.401-.615.59 0 1.058.246 1.476.762l7.057 8.754 7.033-8.754c.418-.492.934-.737 1.524-.737z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoLiqpayMain);
export default __webpack_public_path__ + "static/media/logo-liqpay-main.7e754105f16986283a0facedc763a2e5.svg";
export { ForwardRef as ReactComponent };